import { render, staticRenderFns } from "./popup-generate-stock-in.vue?vue&type=template&id=bd8f4964&scoped=true"
import script from "./popup-generate-stock-in.vue?vue&type=script&lang=js"
export * from "./popup-generate-stock-in.vue?vue&type=script&lang=js"
import style0 from "./popup-generate-stock-in.vue?vue&type=style&index=0&id=bd8f4964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f4964",
  null
  
)

export default component.exports